class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));

    if (this.closest('.header__inline-menu')) {
      const details = this.mainDetailsToggle;
      const summary = details.querySelector(':scope > summary');
      const stickyHeader = this.closest('sticky-header');
      summary.setAttribute('aria-expanded', String(details.open));

      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        details.classList.toggle('sub-menu-opening', details.open);
        if (details.open && typeof stickyHeader?.openSubMenu === 'function') {
          stickyHeader.openSubMenu(details);
        }
      });

      summary.addEventListener('click', (event) => {
        const parentLink = event.target.closest('a');
        if (!parentLink || !summary.contains(parentLink)) return;
        const arrowClick = event.target.closest('.icon-arrow');
        if (parentLink.getAttribute('href') !== '#' && !arrowClick) return;
        event.preventDefault();
        if (stickyHeader) {
          window.clearTimeout(stickyHeader.timeoutOpen);
          window.clearTimeout(stickyHeader.timeoutClose);
          stickyHeader.openingMenu = false;
          stickyHeader.closingMenu = false;
        }
        details.open = !details.open;
      });
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
